package one.healthium.ricediet.presentation.navigation.home.compose

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import kotlinx.coroutines.launch
import loco.MAIN_NAVIGATION_CHAT_LABEL
import loco.MAIN_NAVIGATION_DAILY_LABEL
import loco.MAIN_NAVIGATION_INSIGHTS_LABEL
import loco.MAIN_NAVIGATION_ME_LABEL
import loco.MAIN_NAVIGATION_TODAY_LABEL
import one.healthium.ricediet.presentation.navigation.home.HomeComponent
import one.healthium.tasks.ui.DailyTasksBadge
import one.healthium.ui.compose.components.AppNavigationBar
import one.healthium.ui.compose.components.AppNavigationBarItem
import one.healthium.ui.compose.components.LocalGlobalProgressIndicator
import one.healthium.ui.compose.components.NavigationBarText
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun BottomNavigation(
    component: HomeComponent,
) {
    val stack by component.stack.subscribeAsState()
    val activeComponent = stack.active.instance
    val scope = rememberCoroutineScope()
    val globalProgressIndicator = LocalGlobalProgressIndicator.current

    AppNavigationBar(
        color = AppTheme.colors.primary,
    ) {
        // Today
        AppNavigationBarItem(
            modifier = Modifier.weight(1f),
            icon = {
                NavigationBarText(
                    label = stringResource(loco.Res.string.MAIN_NAVIGATION_TODAY_LABEL),
                    active = activeComponent is HomeComponent.Child.TodayChild,
                )
            },
            selected = activeComponent is HomeComponent.Child.TodayChild,
            onClick = component::onTodayTabClicked,
        )

        // DailyTasks
        AppNavigationBarItem(
            modifier = Modifier.weight(1f),
            icon = {
                Box {
                    NavigationBarText(
                        label = stringResource(loco.Res.string.MAIN_NAVIGATION_DAILY_LABEL),
                        active = activeComponent is HomeComponent.Child.DailyTasksChild,
                    )
                    DailyTasksBadge(
                        modifier = Modifier
                            .align(Alignment.TopEnd)
                            .offset(x = 10.dp, y = -(2).dp)
                    )
                }
            },
            selected = activeComponent is HomeComponent.Child.DailyTasksChild,
            onClick = component::onDailyTasksTabClicked,
        )

        // Insights
        AppNavigationBarItem(
            modifier = Modifier.weight(1f),
            icon = {
                NavigationBarText(
                    label = stringResource(loco.Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL),
                    active = activeComponent is HomeComponent.Child.InsightsChild
                )
            },
            selected = activeComponent is HomeComponent.Child.InsightsChild,
            onClick = component::onInsightsTabClicked,
        )

        // Chat
        AppNavigationBarItem(
            modifier = Modifier.weight(1f),
            icon = {
                NavigationBarText(
                    label = stringResource(loco.Res.string.MAIN_NAVIGATION_CHAT_LABEL),
                    active = activeComponent is HomeComponent.Child.ChatChild,
                )
            },
            selected = activeComponent is HomeComponent.Child.ChatChild,
            onClick = {
                scope.launch {
                    globalProgressIndicator.value = true
                    component.onChatTabClicked()
                    globalProgressIndicator.value = false
                }
            },
        )

        // Profile
        AppNavigationBarItem(
            modifier = Modifier.weight(1f),
            icon = {
                NavigationBarText(
                    label = stringResource(loco.Res.string.MAIN_NAVIGATION_ME_LABEL),
                    active = activeComponent is HomeComponent.Child.ProfileChild,
                )
            },
            selected = activeComponent is HomeComponent.Child.ProfileChild,
            onClick = component::onProfileTabClicked,
        )
    }
}
